export default class Company {
	id: number;     //ид
	name: string;   //название фирмы
	activity = true;
}